import EBRServiceDetail from "./EBRServiceDetail";

export default EBRServiceDetail;
